import React from 'react';
import { connect } from 'react-redux';
import { EmptyTableMsg } from './EmptyTableMsg';
import { PencilIcon } from './icons/PencilIcon';
import { TrashIcon } from './icons/TrashIcon';
import { HomeIcon } from './icons/HomeIcon';
import { PicListsInputBar } from './PicListsInputBar';
import { updateTodosList, startUpdateTodosList } from '../actions/todos';
import { clearPicAppError } from '../actions/picapp';
import { SortableContainer, SortableElement, arrayMove,} from 'react-sortable-hoc';
import  PicGetRequest  from '../apis/PicGetRequest';
import { SimpleButton } from './buttons/SimpleButton';
import { ShadowButton } from './buttons/ShadowButton';
import { history }  from '../routers/AppRouter'


//**********************************************************************
// This component is known as a LoiT (List of Items Table). This component
// is an implementation of the ListOfItemsTable Component. It provides
// both a list of items table with an input bar and edit and delete icons.
// To reuse it, it requires making a copy of this base component and making 
// modifications listed below. Note that the component is responsible for
// managing its own data. The changes below are predominantly changes that
// are needed based on whether data is sourced from local state or redux.
//**********************************************************************

// Props needed by this component:
//  raiseError: this is the function used to raise error to parent
// See changes needed, when planning to reuse this as a separate component:
// 1) Update the componentDidMount with method to initialize your state for
//    items. This maybe an assignment if using local state or a dispatch method
//    if using redux.
// 2) Update the onSortEnd method to source copy of list from your where you are 
//    storing items: local state or redux, and update line where you update
//    the store before exiting.
// 3) Update the items prop inside renderSortableList() method to where
//    your storing items: local state or redux, and use same reference for
//    copyListWithJsx
// 4) Update following your onSubmitMethod to reflect source of item list 
//    (eg, redux  or local state) where you are making copy from 
// 5) Update following your handleEditItem and handleDeleteItem methods to 
//    reflect correct source of data (eg Local state or redux). Also change 
//    code that updates store with modified array.
// 6) Update isFormValid() method with error message text required for each error
// 7) Update addItemToList to reflect your source of data. Also update last line which
//    updates the store.
// 8) If using redux to save state, update mapStateToProps and mapDispatchToProps
//    with state and dispatch method need for updating list.
// 9) update displayEmptyTableMsg with message you would like to display
//    when table is empty
// ****************************************************************** */
// React-Sortable Styles
// ****************************************************************** */
/* These are styles that I added to react-sortable for puposes of having
   the row (SortableElement) render using flex. The container style was
   added to provide scroll bar. */
// let elementStyle = {
//   display: 'flex', 
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   borderBottom: '1px solid grey',
//   height: '4rem',
// }
// let containerStyle = {
//   overflowY: 'scroll',
//   width: '100vw',
//   height: '36rem',
//   borderBottom: '2px solid grey',
//   borderLeft: '1px solid grey'
// }

// ****************************************************************** */
// Functions to generate the JSX for the first two columns in table
// ****************************************************************** */
/* Note that these functions are outside the Class scope because they 
   are called by React SortableList which also sits outside of Class scope as well.
   This allows me to keep the raw data in column 1 and 2 and only return
   the JSX below when rendering the SortableList. Column 3 (edit and delelete icons), on the other
   hand, has to be popluated within the scope of the component itself so the onclicks can
   be bound to the event handlers in the Class. */

/* Functions used for rendering todo and number of PeopleNeeded fields*/
const getColumn1Jsx = (todo) => {
  return <div className="pic-lists-col1" key="1" >{todo}</div>
}
/* This is quantity field */
const getColumn2Jsx = (peopleNeeded) => {
  return <div className="pic-lists-col2" key="2">{peopleNeeded}</div>
}

// ****************************************************************** */
// Following 2 functions: SortableItem and SortableContainer are part of 
// the React-sortable-HOC and should not be modified. 
// Below I've documented some Minor changes I've made to get it to work
// ****************************************************************** */
/* Changes Made*/
/*  I replaced <li> with a <div> for SortableItem and added the style attribute
   to be able to display JSX as row instead vertically. Note: SortableElement is
   equivalent to a row. I also added the style attribute defined above to the SortableContainer.
   Added in line to convert the raw values to JSX as the component maps over items during runtime.
   The reason I did this was to  maintain the raw values in the array so column3
   (which has the onclicks events for edit and delete) can access the raw data vs jsx.
   The 3rd array element, which is the jsx for the edit and delete icons themselves, I populate
   when I render but then remove everytime I update redux store as it causes circular error. */

  //  const SortableItem = SortableElement(({value}) => <div style={elementStyle} >{value}</div>) 
  const SortableItem = SortableElement( ({value}) => {
    return (<div className="pic-lists-element-style" >{value}</div>)
  } );

   /* Below I also replaced <ul> tag wit div; this removed the space from left */
   const SortableList = SortableContainer(({items}) => {
     return (
       <div className="pic-lists-sortable-container">
         {  items.map((item, index) => {
              /* Line below is what I injected to convert an item object to an item array as react can render an array but not an object.  */
              let styledValue = [getColumn1Jsx(item.todo), getColumn2Jsx(item.peopleNeeded), item.actionIconsJsx];
              return (
                <SortableItem key={`item-${index}`} index={index} value={styledValue} />
              )
            })
         }
       </div>
     );
   });

// ****************************************************************** */
// PicListsPage component
// ****************************************************************** */
class PicListLoiTHelpingHands extends React.Component {
  state = {
    items: [],             /* generic container used to hold type of items: (eg "todos" "Things to bring", etc */
    dataValue1: '',
    dataValue2:  '',
    editItem: false,      /* this tell onSubmit whether submission is for adding new item or editing existing*/
    edititemIndex: -1, 
    /* Following 2 properties are used for update throttling mechanism */
    maxUpdates: 300,       /* this is max number of store updates before writing to database */
    numUpdates: 0,       /* this keeps track of number of updates made. it will be reset to zero when it hits maxUpdates */
    formError: ''
  };

  /* Used to initialize list of items from database. */
  componentDidMount = () => {

    /* Obtain values from store needed to fire API Request */
    let event_id = this.props.event.active._id;
    let userid   = this.props.auth.user.email;  
    let token    = this.props.auth.token;
    let items = [];

    /* Fire API Request */
    let getRequest = new PicGetRequest("GetTodosList")
            .setUserId(userid)
            .setUri(`/event/${event_id}/todos`)
            .setAuthToken(token)
            .setLogTrace(true);
    getRequest.exec().then( (response) => {
            items = response.data.todos || [];  /* assign todos to generic container items */
            this.props.updateTodosList(items);
    }).catch((error) => {
              this.setState({
                formError: 'Server Busy: please try again later'
              })
    });
  }

  /* Used flush any updates that have not
     been written to database by "throttleTableUpdate function" at point of dismount. NOTE: since
     you are unmounting component you do not need to update the store, just apply store updates to DB.
     Note. that clicking away from the page, does not constitute an update, hence no changes are made
     to redux store, but any changes that not been externalized, should be written to database at this time */
  componentWillUnmount= () => {
    /* clear any error message if one exist; so its does not carry over to next page */
    if (this.props.picapp.error) {
      this.props.clearPicAppError();
    }
  }

  // ****************************************************************** */
  // React-Sortable 3rd Party function onSortEnd
  // ****************************************************************** */
  /* onSortEnd gets called after sort (row is dragged).                */
  /* Changes made -  I wrapped the reac-sortable code with an if statement.
     This will not allow user from dragging a row if item is being edited, although
     it will allow user to drag rows when editItem flag is false (user is adding items). 
     I replaced  setState with updateItemList, which updates
     redux store instead of local state.
     I also added the function "copyListAndRemoveJsx()" after arrayMove function
     call  and  before updating redux (updateItemList). This avoids storing any
     JSX in redux, which  causes circular issues. */
  onSortEnd = ({oldIndex, newIndex}) => {
    if (!this.state.editItem) {
      // this.setState({
      //   items: arrayMove(this.props.todos.list, oldIndex, newIndex),
      // });
      /* make copy of array */
      let itemsCopy = this.props.todos.list;
      /* here React Sortable does its magic on the copy */
      let modifiedList = arrayMove(itemsCopy, oldIndex, newIndex);
      /* strip out jsx column (col 3) and update redux store */
      // let itemList = this.removeJsxFromColumn3(modifiedList);
      let itemsList = this.copyListAndRemoveJsx(modifiedList);
      // this.setState({items: itemList})
      // this.props.updateItemList(itemList);
      this.throttleTableUpdate(itemsList);
      // this.regenJsxforColumn3();
    }
  };

  // ****************************************************************** */
  // React-SortableList 
  // ****************************************************************** */
  /* Changes made:
     1) Wrapped the SortableList component in a function. 
     2) Added line to generate the jsx (for edit and delete icons) before 
       rendering. This must be done each time because storing jsx in redux 
       is problematic, hence jsx  is removed when saving in redux
       and added here when rendering. */
  renderSortableList = () => {
    /* Get a copy of list from redux store and generate the JSX for column3 */
    let modifiedList = this.copyListWithJsx(this.props.todos.list);
  
    /* Return the SortableList component. Note that the props distance={1} 
       avoids swallowing my onClick events. See npm doc for React-Sortable-Hoc*/
    return (
      <SortableList className="sortablelist" 
          items={modifiedList}
          onSortEnd={this.onSortEnd} 
          distance={1} 
      />
    )
  }

  // ****************************************************************** */
  // Event Handlers
  // ****************************************************************** */
  /* The submit does two checks. 1) checks for valid form data on input bar
  and 2) checks whether user is editing an item. If so, it resets flag 
  that is used by onSortEnd to prevent user from dragging row while editing. */
  onSubmit = (e) => {
    e.preventDefault();
    let {editItem, editItemIndex, dataValue1, dataValue2} = this.state;

    if (this.isFormValid()) {     
      if (!editItem) {  
        /* add item  to list */
        this.addItemtoList();
        /* clear out inputs and formError */
        this.setState({                                
          dataValue1: '',
          dataValue2:  '',
          formError: ''
        })
      } else {  /* we're editing item */
        /* make copy of array */
        let itemsCopy = this.copyListAndRemoveJsx(this.props.todos.list);
        /* update the array copy with the item and dataValue2 provided on input bar */
        itemsCopy[editItemIndex].todo = dataValue1;
        itemsCopy[editItemIndex].peopleNeeded = dataValue2.toString();
        /* replace array in redux with updated version  */
        this.throttleTableUpdate(itemsCopy);
        /* clear input fields, note that editItem would be set to true by handleEditItem */
        this.setState({ 
            dataValue1: '',
            dataValue2: '',
            editItem: false,
            editItemIndex: -1
        });
      }
    } 
  }

  /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
  // clearErrorMessage = () => {
  //   this.setState({formError: ''})
  // }
  
  /* used by input bar to enter item field */
  onChangeValue1 = (dataValue1) => {
    this.setState({dataValue1});
  }

  /* used by input bar to enter dataValue2 field */
  onChangeValue2 = (dataValue2) => {
    this.setState({dataValue2});
  }

  /* fired when user clicks pencil(edit) icon, code fetches values to display in input bar for edit */
  handleEditItem = (indexValue) => {
    // let { items } = this.state;
    /* get reference to array in redux*/
    let items = this.props.todos.list;
    /* update local state with item and dataValue2 for the given index */
    this.setState({dataValue1: items[indexValue].todo, 
                   dataValue2:  parseInt(items[indexValue].peopleNeeded, 10),
                   editItem: true,
                   editItemIndex: indexValue});

  }

  /* fired when user clicks trash icon (delete) */
  handleDeleteItem = (indexValue) => {
    /* make copy of array */
    let itemsCopy = this.copyListAndRemoveJsx(this.props.todos.list);
    /* delete item at index value from copy*/
    itemsCopy.splice(indexValue, 1);
    
    /* replace array in store */
    this.throttleTableUpdate(itemsCopy);
    /* clear input fields*/
    this.setState({
        dataValue1: '',
        dataValue2: '',
        editItem: false,
        editItemIndex: -1
    });
  }

  handleOnClickBackButton = (e) => {
    e.preventDefault();
    // history.push("/eventmanage/people")
     /* the following handler is passed in from PicListPage to this component to be 
       able to call it simulate a button press to go to previous page. It goes from Helping Hands list to contributions list. */
    this.props.buttonEventHandler("firstButton");
  }

  /* does save in place */
  handleSaveHelpItems = (e) => {
    let saveAndNext = false;
    this.saveHelpItems(saveAndNext );
  }
  
  /* does save and moves to next screen */
  handleSaveHelpAndNext = (e) => {
    if (this.state.dataValue1) {
      this.props.raiseError('Pending Entry: add or clear input before hitting Save/Next');
    } else {  /* save and go to next page. Before doing so clear any error to avoid a Pending Entry Error to carry forward to next page */
      this.props.clearError();
      let saveAndNext = true;
      this.saveHelpItems(saveAndNext);
    }
  }

  saveHelpItems = (saveAndNext) => {
    console.log('This is saveAndNext in save help items', saveAndNext);

    /* make copy of arraylist */
    let todosCopy = this.copyListAndRemoveJsx(this.props.todos.list);

    /* update redux store and database */
    this.props.startUpdateTodosList(todosCopy, saveAndNext);

    /* reset num updates */
    this.setState({numUpdates: 0 });
  }


  // ****************************************************************** */
  // Utility / Helper methods.
  // ****************************************************************** */

  /* validate entries on input bar; Note that raiseError is callback function that is owned by parent
     as it is the parent that displays error message on screen */
  isFormValid = () => {
    let valid = false;
    if (!this.state.dataValue1 || !this.state.dataValue2) {
      // this.setState(() => ({ formError: 'Missing Entries: we recommend entering both dataValue1 and quantity'}));
      this.props.raiseError('Missing Entries: please enter both help item and number of people');
    } else 
    if (this.state.dataValue1.length > 85) {
      this.props.raiseError('Too Many Characters: upto 85 characters allowed');
        // this.setState(() => ({ formError: 'Too Many Characters: upto 85 characters allowed'}));
    } else 
    if (this.state.dataValue2 < 1) {
        // this.setState(() => ({ formError: 'Check Quantity: value should be greater than 0'}));
        this.props.raiseError("Check Number of People: should be greater than 0");
    } else {
      this.props.raiseError('');
      valid = true;
    return valid;
    }
  }

  /* Add entry to list; this is called by onSubmit to add entries to list*/
  addItemtoList = () => {
    /* destructure state */
    let { dataValue1, dataValue2 } = this.state;

    /* make copy of arraylist */
    let itemsCopy = this.copyListAndRemoveJsx(this.props.todos.list);
    /* Add Sortable element (or row) as last row on the list. Item and dataValue2 are added 
       as raw values (not jsx) and a blank placeholder for actionItemsJsx property. The 
       actionIconsJsx property is left out of the item object purposefully as it only needs
       to get added when rendering, and not pushed to redux store  */
    itemsCopy.push({ todo: dataValue1, peopleNeeded: dataValue2.toString(), actionIconsJsx: "" }); 
    /* update state with new copy of array list */
    this.throttleTableUpdate(itemsCopy);
    // this.setState({items: itemsCopy});
  }

  /* Used to display message when table is empty */
  displayEmptyTableMsg = () => {
    return (
      <div className="empty-table-msg-container" >
          <EmptyTableMsg className="empty-table-msg-with-topmargin"
              emptymsg={'Add items above where people can help' }
          />
      </div>
    )
  } 
  
  /* As the method says, this is used to return the action icons Jsx while making sure the
     on click event handlers are bound to the correct index entry */ 
  bindActionIconsToIndex = (idx) => {
    return (
      <div className="pic-lists-col3" key="3" >
        <div onClick={ this.handleEditItem.bind(this, idx) } className="pencil-icon-button">
          <PencilIcon color="grey" size="small" />
        </div>     
        <div onClick={ this.handleDeleteItem.bind(this,idx)} className="trash-icon-button">
          <TrashIcon color="grey" size="small" />
        </div>     
      </div>
    )
  }

/* This function makes a deep copy of the array of objects, while also clearing out the 
   actionIconsJsx property. This function is required because saving jsx in redux causes problems.
   Therefore, this function is called right before updating redux (via throttleTableUpdate), 
   so as to remove actionIcons jsx before saving it to redux. The JSX is later added back 
   right before rendering (via renderSortableList) */
  copyListAndRemoveJsx =  (list = []) => {
    let newList = [];
    list.forEach((item) => {
        newList.push({
            todo: item.todo,
            peopleNeeded: item.peopleNeeded,
            actionIconsJsx: ""
        });
    });
      /* return modified copy of list */
    return newList;
  }
  /* This function makes copy of list, generates the JSX for the action icons,
     binds the action icons to the index value, and returns modified list */
  copyListWithJsx =  (list) => {
    let newList = [];
    list.forEach((item, index) => {
        newList.push({
            todo: item.todo,
            peopleNeeded: item.peopleNeeded,
            actionIconsJsx: this.bindActionIconsToIndex(index)
        });
    });
      /* return modified copy of list */
    return newList;
  }

  // ****************************************************************** */
  // Performance related function called throttleTableUpate.
  // Function is designed to reduce the number 
  // of writes to the database.  The value maxUpdates is used as
  // threshold value for writing to database. When threshold value is hit,
  // we update database and reset it to 0. If user  leaves the page,
  // or logs off before the threshold is maxed, then componentWillUnmount will
  // check if there are any updates that have not been persisted. If so
  // It will take care of flushing out the last changes that were made.
  // NOTE: this function should NOT receive an array list that is a reference
  // to redux store,  but a copy with required modifications alread applied.
  // ****************************************************************** */
  throttleTableUpdate = (items) => {
    this.setState( (state) => {
      if (state.numUpdates === state.maxUpdates )  { /* Reached the update threshold; update both redux store and to database */
          this.props.startUpdateTodosList(items)
          return { numUpdates: 0 } 
      } else { /* Did not reach update threshold, just update the redux store */
          this.props.updateTodosList(items)
          return { numUpdates: this.state.numUpdates + 1 }
      }
    });
  };

  /* This function is called by componentWillUnmount to flush out any updates 
     that have not been applied by "throttleTablepdate" when user switches 
     off the this page or logs off. NOTE: since you are unmounting component
     you do not need to update the store, just check if store updates have been applied
     and if not, update DB. Note that logout action, for example, will 
     update the store to empty list and switching off this page does not make changes
     to store, hence only DB needs to be applied */
  // flushTableUpdates = (items = []) => {
  //   trace && prtStart(compName, 'flushTableUpdates');
  //   trace && prtVar('numUpdates', this.state.numUpdates);
     
  //   trace && prtMsg("BELOW are props visible to flushTableUpdates")
  //   console.log(this.props);

  //   /* Reached the update threshold; set the flag to true and write to both redux store and to database */
  //   if (this.state.numUpdates > 0 )  {
  //       trace && prtMsg('Im inside flushTableUpdates / num updates are > 0');
  //       trace && prtMsg("dispatch action startUpdateTodosList ");
  //       this.props.startUpdateTodosList(items)
  //   } else {trace && prtMsg('OUTSIDE flushTableUpdates if block ; IF condition was not met');}

  //   trace && prtEnd(compName, 'flushTableUpdates');
  // };

  // ****************************************************************** */
  // Main render() function
  // ****************************************************************** */
  // About Components in render
  // PicListsInputBar: requires that you provide onSubmit method for the parent(which is this page).
  //   When someone enters value, state values are maintained here and passed to child component 
  //   (PicListInputBar) as props for rendering. On Change handlers also update state here.
  // renderSortableList Function: renders React-Sortable-HOC. 
  // displayEmptyTableMessage():  renders messsge when table is empty.
  render() {
    // Pull errormsg from state, if any. ErrorMessage component will only render if this errormsg has text.
    // let errormsg = this.state.formError || '';
    let items_length = this.props.todos.list !== undefined ? this.props.todos.list.length : 0;

    return (
      <div>
          <div className="pic-lists-inputbar-container">
            <PicListsInputBar
                placeholder1={"Enter help needed  (eg. stack chairs, put up decorations, etc)"}
                placeholder2={"# People"}
                inputValue1={this.state.dataValue1}
                inputValue2={this.state.dataValue2}
                onChangeValue1={this.onChangeValue1}
                onChangeValue2={this.onChangeValue2}
                parentOnSubmit={this.onSubmit}
            />
              {items_length > 0 
                  ? this.renderSortableList()
                  : (<div className="pic-lists-mb-space25">
                      {this.displayEmptyTableMsg()}
                    </div>)
              }
          </div>
          <div className="pic-lists-buttons-container">
              <div className="eventinfo-back-button-container">
                  <ShadowButton  buttonText="Back" words={1} onClickHandler={this.handleOnClickBackButton} />
                  <div className='eventinfo-modifier-plr1'>
                    <div onClick={ () => { history.push("/dashboard")} }><HomeIcon /></div>
                  </div>
              </div>
              <div className="pic-lists-right-buttons-container">
                <ShadowButton buttonText="Save" words={1} onClickHandler={this.handleSaveHelpItems} />
                <div>&nbsp;</div>
                <SimpleButton buttonText="Save / Next" words={2} onClickHandler={this.handleSaveHelpAndNext} />
              </div>
          </div>
      </div>
      ); /* end of return */
  } /* end of render() */
} /* end of class PicListsPage */

const mapStateToProps = (state) => {
  return {
      auth:   state.auth,
      event: state.event,
      picapp: state.picapp,
      todos: state.todos
  };
};

const mapDispatchToProps = (dispatch) => ({
  startUpdateTodosList:  (items, saveAndNext) => dispatch(startUpdateTodosList(items, saveAndNext)),
  updateTodosList:       (items) => dispatch(updateTodosList(items)), 
  clearPicAppError:     () => dispatch(clearPicAppError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicListLoiTHelpingHands);


/*

*/


// WEBPACK FOOTER //
// ./src/components/PicListLoiTHelpingHands.js